import { Avatar, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { Fan } from "../models";
import { formatDate } from "@arelia-utils/helpers/dates";

type Props = {
  activeFan: Fan | null;
};

export default function QuickView({ activeFan }: Props) {
  return activeFan && <Box sx={styles.wrapperBox}>
    <Box sx={styles.userInfoBox}>
        <Avatar sx={styles.avatar}></Avatar>
        <Typography variant="h3">{activeFan.fullName}</Typography>
        <Typography variant="h3" color="primary">{activeFan.email}</Typography>
    </Box>
    <div style={styles.divider}></div>
    <Box sx={styles.userDetailsBox}>
        <Typography variant="h4">{activeFan.phone}</Typography>
        <Typography variant="h4">{activeFan.country}</Typography>
        <Typography variant="h4">{activeFan.city}</Typography>
        <Typography variant="h4">{formatDate(activeFan.createdAt, "MM/dd/yy hh:mm aa")}</Typography>
    </Box>
  </Box>;
}

const styles = {
  wrapperBox: {
    display: "flex",
    flexDirection: "column"
  },
  userInfoBox: {
    gap: "5px",
    display: "flex",
    alignItems: "center",
    flexDirection: "column"
  },
  divider: {
    backgroundColor: "rgba(129, 140, 155, 0.2)",
    height: "1px",
    width: "100%",
    margin: "14px 0"
  },
  userDetailsBox: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column"
  },
  avatar: {
    borderRadius: "30px"
  },
}